exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.height-user[data-v-0ef73c1c] {\n  max-height: 890px;\n}\n.image-button[data-v-0ef73c1c] {\n  cursor: pointer;\n  margin: 0 .25rem;\n}\n", ""]);

// exports
